import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import M from 'materialize-css/dist/js/materialize';
import InventoryService from '../../../../../services/InventoryService';
import PartNumberService from '../../../../../services/PartNumberService';
import { translate, leftPad, isNullOrEmpty } from '../../../../../utils/util';
import { ENUMS, VISIONS } from '../../../../../utils/constants';
import * as lineInventoryAction from '../../../../../actions/inventoryAction';
import { ConfirmModal, Button, Input, ScannerCode } from '../../../../../components/UI/ComponentsUI';
import { getVision } from '../../../../../services/auth';

const LotItemDetail = (props) => {
    const [lotItem, setLotItem] = useState();
    const [partNumber, setPartNumber] = useState();
    const [qrCode, setQrcode] = useState('');
    const [countItem, setCountItem] = useState();
    const [codeValid, setCodeValid] = useState(false);
    const [location, setLocation] = useState("");
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (props.lotItem) {
            setLotItem(props.lotItem);
            M.updateTextFields();
        }
    }, [props.lotItem]);

    const setLocationCode = (value) => {
        if (!isNullOrEmpty(value)) {
            setLocation(value);
        }
        else {
            setLocation("");
        }
        M.updateTextFields();
    };

    const scanner = (value) => {
        if (value.length >= 2) {
            setCodeValid(true);
            setQrcode(value);
        } else {
            setCodeValid(false);
        }
        M.updateTextFields();
    };

    const isValid = () => {
        return codeValid
            && !isNullOrEmpty(partNumber?.partNumberId)
            && !isNullOrEmpty(partNumber?.partNumberCode)
            && !isNullOrEmpty(location)
            && !isNullOrEmpty(countItem) && parseInt(countItem, 10) >= 0;
    };

    const disableQrCode = () => {
        return (parseInt(countItem || 0)) <= 0;
    }

    const onConfirm = () => {
        if (isValid()) {
            lotItem.inventoryId = props.filter.inventoryId;
            lotItem.validationCode = qrCode;
            lotItem.location = location;
            lotItem.partNumberCode = partNumber.partNumberCode;
            lotItem.partNumberDescription = partNumber.partNumberDescription;
            lotItem.partNumberId = partNumber.partNumberId;
            props.readingItem(lotItem, countItem, props.user.vision, () => {
                getNexReading();
            });
        }
    };

    const getNexReading = () => {
        const listItemLot = props.lotItems.items.filter((m) => m.status !== ENUMS.eInventoryLotItemStatus.Finished.value && m.status !== ENUMS.eInventoryLotItemStatus.Canceled.value);
        if (listItemLot.length > 0) {
            setQrcode('');
            setCountItem('');
            setCodeValid(false);
            setLotItem({});
            setPartNumber({});
            setLocation('');
            if (document.getElementById('partNumberCode')) {
                document.getElementById('partNumberCode').value = '';
            }
            if (document.getElementById('location')) {
                document.getElementById('location').value = '';
            }
            if (document.getElementById('firstCount')) {
                document.getElementById('firstCount').value = '';
            }
            props.setSelectedLotItem(listItemLot[0]);
        } else {
            props.history.go(-2);
        }
    };

    const onBlurPartNumber = (value) => {
        if (!isNullOrEmpty(value)) {
            value = leftPad(value, 11, '0');
            lotItem.partNumberCode = value;
            document.getElementById("partNumberCode").value = value;
            setLotItem(lotItem);

            props.getPartNumberValidate(props.inventory.id, value, (response) => {
                if (response && response.data && !response.data.name.includes('INEXISTENTE')) {
                    var vision = getVision();
                    if ((response.data.familyCode === '99' && vision === VISIONS.Jeep) || (response.data.familyCode === 'M1' && !isNullOrEmpty(lotItem.lot.zoneCode) && lotItem.lot.zoneCode.substring(0, 1) === '2' && vision === VISIONS.Fiasa)) {
                        setMessage(translate('inventory:part-number-giro'));
                        const modal = M.Modal.init(document.getElementById('partNumberConfirm'));
                        modal.open();
                    } else {
                        const part = {};
                        part.partNumberCode = response.data.partnumberCode;
                        part.partNumberDescription = response.data.name;
                        part.partNumberId = response.data.partnumberID;
                        setPartNumber(part);
                    }
                    M.updateTextFields();
                } else {
                    setPartNumber();
                }
            });
        } else {
            setPartNumber();
        }
    };

    const onConfirmModal = () => {
        setPartNumber();
        document.getElementById("partNumberCode").value = undefined;
    };

    return (
        lotItem?.lotItemId ? (
            <div className="container">
                <div className="card">
                    <div className="card-content" style={{ padding: '7px' }}>
                        <form>
                            <div className="row" style={{ marginBottom: '0' }}>
                                <div className="row">
                                    <div className="input-field no-padding col s6">
                                        <span className="field f-1r truncate">{props.filter.lotNumber || lotItem.lotNumber}</span>
                                        <label className="active" htmlFor="lotNumber"> {translate('inventory:lot')}</label>
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <span className="field f-1r truncate">{lotItem?.lotItemNumber}</span>
                                        <label className="active" htmlFor="lotItemNumber"> {translate('inventory:inventoryNote')}</label>
                                    </div>
                                </div>
                                <div className="input-field no-padding col s8">
                                    <ScannerCode onScanner={onBlurPartNumber} markerCodeBar={true} />
                                    <Input
                                        id="partNumberCode"
                                        required
                                        type="number"
                                        defaultValue={partNumber?.partNumberCode}
                                        maxLength="11"
                                        onBlur={(ev) => { onBlurPartNumber(ev.currentTarget.value); }}
                                    />
                                    <label className="required" htmlFor="partNumberCode">{translate('inventory:partNumber')}</label>
                                </div>
                                <div className="input-field no-padding col s12">
                                    <span className="field f-1r truncate">{partNumber?.partNumberDescription}</span>
                                    <label className="active" htmlFor="partNumberDescription">{translate('inventory:partNumberDescription')}</label>
                                </div>
                                <div className="input-field no-padding col s8">
                                    <ScannerCode onScanner={setLocationCode} markerCodeBar={true} />
                                    <Input
                                        id="location"
                                        value={location}
                                        required
                                        name="location"
                                        type="text"
                                        onChange={(ev) => { setLocationCode(ev.currentTarget.value); }}
                                        maxLength={200}
                                    />
                                    <label className="required" htmlFor="location">{translate('inventory:location')}</label>
                                </div>
                                <div className="row">
                                    <div className="input-field no-padding col s12">
                                        <Input required id="firstCount" type="number" name="firstCount" min="1" onChange={(ev) => {
                                            setCountItem(ev.currentTarget.value);
                                            if (codeValid && (isNullOrEmpty(ev.currentTarget.value) || ev.currentTarget.value === 0)) {
                                                setCodeValid(false)
                                                setQrcode("");
                                            }
                                        }} />
                                        <label className="required" htmlFor="firstCount">{translate('inventory:firstCount')}</label>
                                    </div>
                                </div>
                                <div className="input-field no-padding col s6">
                                    <ScannerCode disabledValidate={disableQrCode} className="mdi mdi-qrcode-scan posfix" onScanner={scanner} />
                                    <input disabled id="qrcode" type="text" placeholder={translate('general.validate')} value={qrCode} />
                                </div>
                                <div className="input-field no-padding col s2">
                                    {
                                        codeValid ? (
                                            <i className="mdi mdi-checkbox-marked-circle-outline right f-2r" style={{ color: 'green' }} />
                                        ) : (
                                            <i className="mdi mdi-alert-circle-outline right f-2r" style={{ color: 'red' }} />
                                        )
                                    }
                                </div>
                            </div>
                            <div className="row" style={{ padding: '1rem 0', marginBottom: '0' }}>
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} disabled={!isValid()} text={translate('confirm', 'general')} />
                            </div>
                        </form>
                    </div>
                </div>
                <ConfirmModal
                    id="partNumberConfirm"
                    data={{ title: translate('validations.attention'), message }}
                    onConfirm={onConfirmModal}
                    onCancel={onConfirmModal}
                    btnConfirm={translate('confirm', 'general')}
                />
            </div>
        ) : null
    );
};

const mapStateToProps = (state) => {
    return {
        lotItem: state.inventoryReducer.lotItem,
        filter: state.inventoryReducer.filter,
        lotItems: state.inventoryReducer.lotItems,
        user: state.userReducer.user,
        inventory: state.inventoryReducer.inventory
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        readingItem: (reading, quantity, vision, callback) => {
            dispatch(InventoryService.readingLotItem(reading, quantity, vision, callback));
        },
        getLotItem: (lotItemId, vision) => {
            dispatch(InventoryService.getLotItem(lotItemId, vision));
        },
        setSelectedLotItem: (lotItem) => {
            dispatch(lineInventoryAction.selectLotItem(lotItem));
        },
        getPartNumber: (code, callback) => {
            dispatch(PartNumberService.getPartNumber(code, callback));
        },
        getPartNumberValidate: (inventoryId, partNumberCode, callback) => {
            dispatch(InventoryService.getPartNumberValidate(inventoryId, partNumberCode, callback));
        }


    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LotItemDetail)));
